







export default {
  name: 'login-error'
};

